export type Language = 'italian' | 'french'

export const supportedLanguages: Language[] = ['italian', 'french']
